import history from 'aurora-utils/history';
import { ACTIVE_URL_UAE_PASS } from 'aurora-utils/constants';
import { CleverTapProfileLogout } from 'aurora-utils/cleverTap.eventhelper';
import * as types from '../constants';

const { BASE_URL_UAE_PASS_LOGOUT } = ACTIVE_URL_UAE_PASS;
export const logoutSuccess = () => ({
  type: types.LOGOUT_SUCCESS,
});

export const logoutFailure = error => ({
  type: types.LOGOUT_FAILURE,
  payload: {
    error,
  },
});

export const logout = (sop1Error = false) => async dispatch => {
  try {
    console.log('Inside Logout');
    dispatch({ type: types.LOGOUT_REQUEST });
    const lang = localStorage.getItem('lang');
    if (localStorage.getItem('login_with') === 'uaePass') {
      localStorage.clear();
      console.log({ sop1Error });
      if (sop1Error) {
        localStorage.setItem('uae_pass_errorCode', 'VAL200002');
      }
      localStorage.setItem('login_with', 'GuestLogin');
      localStorage.setItem('lang', lang);
      window.location.href = BASE_URL_UAE_PASS_LOGOUT;
      dispatch(logoutSuccess());
      CleverTapProfileLogout();
    } else {
      localStorage.clear();
      localStorage.setItem('login_with', 'GuestLogin');
      localStorage.setItem('lang', lang);
      dispatch(logoutSuccess());
      CleverTapProfileLogout();
      history.push('/');
    }
  } catch (e) {
    dispatch(logoutFailure(e));
  }
};
